var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6068_11746)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 256,
    height: 256,
    rx: 20,
    fill: "#212034"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 1.5,
    width: 255,
    height: 255,
    rx: 19.5,
    stroke: "#292841"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.5 85.0226C153.553 84.7466 153.778 84.5374 154.055 84.4861C158.641 83.6388 162.114 79.6359 162.114 74.8257C162.114 69.3991 157.694 65 152.243 65C146.791 65 142.372 69.3991 142.372 74.8257C142.372 78.274 144.156 81.3073 146.856 83.0608C147.089 83.2123 147.216 83.4863 147.163 83.7587L145.725 91.2019H119.276L117.838 83.7587C117.785 83.4863 117.912 83.2123 118.145 83.0608C120.845 81.3073 122.63 78.274 122.63 74.8257C122.63 69.3991 118.21 65 112.759 65C107.307 65 102.888 69.3991 102.888 74.8257C102.888 79.6359 106.36 83.6388 110.946 84.4861C111.224 84.5374 111.448 84.7466 111.502 85.0226L112.695 91.2019H99.5974C88.6942 91.2019 79.8555 100 79.8555 110.853V153.432C79.8555 164.285 88.6942 173.083 99.5974 173.083H109.468C111.286 173.083 112.759 174.549 112.759 176.358V189.719C112.759 192.369 115.755 193.922 117.936 192.402L140.564 176.635C143.882 174.323 147.835 173.083 151.885 173.083H165.404C176.307 173.083 185.146 164.285 185.146 153.432V110.853C185.146 100 176.307 91.2019 165.404 91.2019H152.306L153.5 85.0226ZM157.178 74.8257C157.178 77.539 154.968 79.7386 152.243 79.7386C149.517 79.7386 147.307 77.539 147.307 74.8257C147.307 72.1124 149.517 69.9129 152.243 69.9129C154.968 69.9129 157.178 72.1124 157.178 74.8257ZM112.759 79.7386C110.033 79.7386 107.823 77.539 107.823 74.8257C107.823 72.1124 110.033 69.9129 112.759 69.9129C115.484 69.9129 117.694 72.1124 117.694 74.8257C117.694 77.539 115.484 79.7386 112.759 79.7386ZM132.501 146.881C124.63 146.881 117.163 145.162 110.458 142.08C109.973 141.801 109.411 141.641 108.81 141.641C106.993 141.641 105.52 143.107 105.52 144.916C105.52 146.218 106.284 147.343 107.39 147.871L107.384 147.883C115.009 151.443 123.522 153.432 132.501 153.432C141.429 153.432 149.895 151.465 157.487 147.944L157.481 147.93C158.657 147.431 159.481 146.269 159.481 144.916C159.481 143.107 158.008 141.641 156.191 141.641C155.59 141.641 155.028 141.801 154.543 142.08C147.838 145.162 140.371 146.881 132.501 146.881ZM111.114 110.853C117.237 110.853 122.244 115.611 122.608 121.615C122.622 121.738 122.63 121.863 122.63 121.989C122.63 123.798 121.157 125.264 119.339 125.264C117.522 125.264 116.049 123.798 116.049 121.989H116.038C115.869 119.429 113.729 117.404 111.114 117.404C108.498 117.404 106.358 119.429 106.189 121.989H106.178C106.178 123.798 104.705 125.264 102.888 125.264C101.071 125.264 99.5974 123.798 99.5974 121.989C99.5974 121.863 99.6046 121.738 99.6186 121.615C99.9827 115.611 104.99 110.853 111.114 110.853ZM165.383 121.615C165.019 115.611 160.011 110.853 153.888 110.853C147.764 110.853 142.757 115.611 142.393 121.615C142.379 121.738 142.372 121.863 142.372 121.989C142.372 123.798 143.845 125.264 145.662 125.264C147.479 125.264 148.952 123.798 148.952 121.989H148.963C149.132 119.429 151.272 117.404 153.888 117.404C156.503 117.404 158.643 119.429 158.812 121.989H158.823C158.823 123.798 160.296 125.264 162.114 125.264C163.931 125.264 165.404 123.798 165.404 121.989C165.404 121.863 165.397 121.738 165.383 121.615Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6068_11746",
    x: 0,
    y: 0,
    width: 264,
    height: 264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6068_11746"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6068_11746",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.7e4bfd9bbc1e8d5b72713ee1a525b170.svg";
export { ForwardRef as ReactComponent };